import { DatastoreProvider } from 'component/navigation/instance';
import { useInstanceConfig } from 'data/instance-config';
import { spaceFeaturesQueryOptions } from 'data/spaces';
import { type RoutePath, Slot, useLocalSearchParams } from 'expo-router';
import { SkeletonTeaserScreen } from 'structure/question/teaser-loading-screen';
import { questionModuleQuery } from 'system/structure-modules';

export function SuspenseFallback() {
    return <SkeletonTeaserScreen />;
}

export default function QuestionInstanceWidgetLayout() {
    const { siloKey, instanceKey } = useLocalSearchParams<Extract<RoutePath, `/[siloKey]/question/[instanceKey]${string}`>>();
    const instanceConfig = useInstanceConfig({
        siloKey,
        structureKey: 'question',
        instanceKey,
        featuresSource: spaceFeaturesQueryOptions,
        moduleQuery: questionModuleQuery,
    });
    return (
        <DatastoreProvider {...instanceConfig} loadingScreen={<SkeletonTeaserScreen />}>
            <Slot />
        </DatastoreProvider>
    );
}
